import Paragraph from '@editorjs/paragraph';

const URL_REGEX = /(?<!=["'])(https?:\/\/[^\s<>"']+)/g;

/**
 * Extended Paragraph tool that preserves empty/blank lines
 * and auto-linkifies URLs in text.
 */
export class PreservingParagraph extends (Paragraph as any) {
  /**
   * Override validate to always return true, allowing empty paragraphs.
   */
  validate(_savedData: any): boolean {
    return true;
  }

  /**
   * Override render to auto-linkify URLs in paragraph text.
   */
  render(): HTMLElement {
    const el = super.render();
    this._linkifyElement(el);
    return el;
  }

  /**
   * Wrap plain-text URLs in <a> tags (skip URLs already inside an anchor).
   */
  private _linkifyElement(el: HTMLElement): void {
    const html = el.innerHTML || '';
    if (!URL_REGEX.test(html)) return;
    URL_REGEX.lastIndex = 0;

    el.innerHTML = html.replace(
      /(<a[^>]*>.*?<\/a>)|((https?:\/\/[^\s<>"']+))/gi,
      (_match, anchorTag, _full, url) => {
        if (anchorTag) return anchorTag;
        return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="ce-auto-link">${url}</a>`;
      }
    );
  }
}
